
import AccountCodeService from "../../services/AccountCodeService";
import {
    ACCOUNT_CODE_CONFIRMED_ACTION,
    ACCOUNT_CODE_FAILED_ACTION,
} from "./actionTypes";
export function AccountCodeListAction() {
    return (dispatch) => {
        AccountCodeService.list()
            .then((response) => {
                dispatch(confirmedAccountCodeAction(response.data));
            })
            .catch((error) => {
                const errorMessage = error.response ? error.response.data : 'Network Error';
                dispatch(accountCodeFailedAction(errorMessage));
            });
    };
}



export function confirmedAccountCodeAction(payload) {
    return {
        type: ACCOUNT_CODE_CONFIRMED_ACTION,
        payload,
    };
}

export function accountCodeFailedAction(data) {
    return {
        type: ACCOUNT_CODE_FAILED_ACTION,
        payload: data,
    };
}

